import { render } from "./AnalyticsCorrectnessPeriodic.vue?vue&type=template&id=b40e3980&scoped=true"
import script from "./AnalyticsCorrectnessPeriodic.vue?vue&type=script&lang=js"
export * from "./AnalyticsCorrectnessPeriodic.vue?vue&type=script&lang=js"

import "@/css/components/analytics-correctness-periodic.css?vue&type=style&index=0&id=b40e3980&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b40e3980"]])

export default __exports__